import { useState } from 'react';
import './Projects.css';
import modalRegistry from './modals/registry';

function Projects({ content }) {
  const [selectedProject, setSelectedProject] = useState(null);
  const SelectedProjectModal = selectedProject ? modalRegistry[selectedProject.modalKey] : null;

  return (
    <section className="section projects" id="projects">
      <div className="section__content">
        <p className="eyebrow">{content.eyebrow}</p>
        <h2 className="section-title">{content.title}</h2>
        <div className="projects__grid">
          {content.items.map((project) => (
            <article className="project-card" key={project.title}>
              {project.image ? (
                <img className="project-card__image" src={project.image} alt="" />
              ) : (
                <div className="project-card__image project-card__image--placeholder" aria-hidden="true" />
              )}
              <div className="project-card__body">
                <h3>{project.title}</h3>
                {project.tools.length > 0 && (
                  <ul className="project-card__tools">{project.tools.map((tool) => <li key={tool}>{tool}</li>)}</ul>
                )}
                {project.description && <p>{project.description}</p>}
                {project.actionType === 'modal' && project.actionLabel && (
                  <button className="project-card__link project-card__link--button" onClick={() => setSelectedProject(project)} type="button">
                    {project.actionLabel} <span aria-hidden="true">↗</span>
                  </button>
                )}
                {project.actionType !== 'modal' && project.url && project.actionLabel && (
                  <a className="project-card__link" href={project.url} target="_blank" rel="noreferrer">{project.actionLabel} <span aria-hidden="true">↗</span></a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
      {SelectedProjectModal && <SelectedProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />}
    </section>
  );
}

export default Projects;
